const ffToColorPickerLine = (field) => ({
    state: field.state,
    hasError: field.error,
    domRef: field.domRef,
});
exports.ffToColorPickerLine = ffToColorPickerLine;
